import { render } from "./FullMouthRehab.vue?vue&type=template&id=0075f5f0"
import script from "./FullMouthRehab.vue?vue&type=script&lang=js"
export * from "./FullMouthRehab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__